import * as React from 'react';
import * as queryString from 'query-string';
import { setHref } from 'login-utils/globalWrappers';
import { ssoCheck } from 'login-apis/lenderSSOAPI';
import { getLoginDefaultValues, QueryProps, SSO_REDIRECT_URL } from './LoginForm/loginFormUtils';
import OldLogin from './OldLogin';
import LoginFormPasswordOnly from './LoginFormPasswordOnly/LoginFormPasswordOnly';
import AppDocumentWrapper from './FormComponents/AppDocumentWrapper';
import './login.scss';

class LoginPasswordOnly extends OldLogin {
  componentDidMount() {
    const { location } = this.props;
    /* istanbul ignore next: (UI-5482) */
    super.componentDidMount();

    const queryProps = queryString.parse(location.search) as QueryProps;
    const { errorMsg } = getLoginDefaultValues(queryProps);
    if (errorMsg) this.setState({ errorMsg });
    this.checkSSO();
  }

  async checkSSO() {
    const { location } = this.props;
    const queryProps = queryString.parse(location.search) as QueryProps;
    if (queryProps.from === 'loginEmail') return;

    try {
      const response = await ssoCheck(queryProps.username!);
      if (response.data.isSSO) {
        setHref(SSO_REDIRECT_URL);
      }
    } catch (e) {
      // if sso check is failed. show an network error
      this.setState({
        errorMsg: 'There was an error. Please try again.',
      });
    }
  }

  render() {
    const { location } = this.props;
    const queryProps = queryString.parse(location.search) as QueryProps;
    const { errorMsg } = this.state;
    return (
      <div className="Login" id="it-LoginPasswordOnly">
        <AppDocumentWrapper footerConfig={null}>
          <LoginFormPasswordOnly errorMsg={errorMsg} username={queryProps.username} />
        </AppDocumentWrapper>
      </div>
    );
  }
}

export default LoginPasswordOnly;
